import { Button, Col, Flex, Row, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormInputNumber, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import FormTimePicker from "components/form/FormProvide/FormTimePicker";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { dataURLtoFile } from "utils/helper";
import Dragger from "antd/es/upload/Dragger";
import { CloudUploadOutlined } from "@ant-design/icons";
import cx from "classnames";
import styles from "../styles/Expense.module.css";

// * VAT rate used to auto-calc "amount excl. VAT" / "VAT" from "total amount incl. VAT"
const VAT_RATE = 0.07;

// * currency is fixed to THB for now - display-only, not persisted to backend
const FIXED_CURRENCY_LABEL = "THB - บาทไทย";

const EditExpenseForm = ({
    setIsExpenseModalOpen = () => { },
    isViewExpenseForm = false,
    initialValues = {},
    updateMyTxnExpense = () => { },
    updateMyTxnExpenseDraft = () => { },
    dropdownProjectByEmployeeId = [],
    EmployeeWelfareDropdown = [],
    CommonTypeByCode = [],
    form,
    isApprove = false,
    onApprove = () => { },
    onReject = () => { },
    selectedExpenseRecord = null,
    handleCancel = () => { },
    onAttachFileChange = () => { },
    onDeleteFile = () => { }
}) => {
    const { t, i18n } = useTranslation();
    const [welfareTypeCode, setWelfareTypeCode] = useState();
    const { employeeInfo } = useSelector((state) => state.expense);

    const [fileSizeInMB, setfileSizeInMB] = useState([]);
    const [fileName, seeFileName] = useState([]);
    const [imageUrl, setImageUrl] = useState([]);
    const [fileType, setFileType] = useState([]);
    const [initialValuesFileName, setInitialValuesFileName] = useState([]);
    const [initialValuesImageUrl, setInitialValuesImageUrl] = useState([]);
    const [initialValuesFileType, setInitialValuesFileType] = useState([]);
    const [initialValuesFileList, setInitialValuesFileList] = useState([]);

    const employeeFullname = i18n.language == "en" ? `${employeeInfo?.nameEn} ${employeeInfo?.surNameEn}` : `${employeeInfo?.name} ${employeeInfo?.surName}`;
    useEffect(() => {
        console.log("initial values ", initialValues);
    }, [initialValues])
    const projectOptions = [
        ...(dropdownProjectByEmployeeId?.map(item => ({
            value: item.stpTimeSheetId,
            label: i18n.language === "en" ? item.projectNameEn : item.projectName
        })) || []),
        { value: null, label: t("expense.no_project") }
    ];

    // * auto-calc "amount excl. VAT" and "VAT" whenever total (incl. VAT) changes
    const handleTotalExpenseChange = (val) => {
        const totalInclVat = Number(val) || 0;
        const amountExcludeVat = totalInclVat / (1 + VAT_RATE);
        const vatAmount = totalInclVat - amountExcludeVat;
        form.setFieldValue("amountExcludeVat", amountExcludeVat.toFixed(2));
        form.setFieldValue("vatAmount", vatAmount.toFixed(2));
    };

    const openBase64InNewTab = (base64Data, mimeType = "application/pdf") => {
        try {
            if (base64Data.startsWith("blob:") || base64Data.startsWith("http")) {
                window.open(base64Data, "_blank", "noopener,noreferrer");
                return;
            }

            const base64 = base64Data.includes(",")
                ? base64Data.split(",")[1]
                : base64Data;

            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: mimeType });
            const blobUrl = URL.createObjectURL(blob);

            window.open(blobUrl, "_blank", "noopener,noreferrer");
            setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);

        } catch (error) {
            console.error("openBase64InNewTab error:", error);
            window.open(base64Data, "_blank", "noopener,noreferrer");
        }
    };
    useEffect(() => {
        if (initialValues) {
            const typeCode = initialValues.welfareTypeCode || initialValues.welfare?.subcategory?.code || initialValues.welfareSubCategoryType?.code;
            const typeId = initialValues.welfareTypeId;

            const selectedOption = EmployeeWelfareDropdown.find(opt =>
                opt.value === typeId
            );

            if (typeCode) {
                setWelfareTypeCode(typeCode);
            }

            form?.setFieldsValue({
                ...initialValues,
                startDate: initialValues.startDate ? (dayjs.isDayjs(initialValues.startDate) ? initialValues.startDate : dayjs(initialValues.startDate)) : undefined,
                endDate: initialValues.endDate ? (dayjs.isDayjs(initialValues.endDate) ? initialValues.endDate : dayjs(initialValues.endDate)) : undefined,
                invoiceDate: initialValues.invoiceDate ? (dayjs.isDayjs(initialValues.invoiceDate) ? initialValues.invoiceDate : dayjs(initialValues.invoiceDate)) : undefined,
                totalMinutes: initialValues.totalMinutes ? (dayjs.isDayjs(initialValues.totalMinutes) ? initialValues.totalMinutes : dayjs(initialValues.totalMinutes, 'HH:mm')) : undefined,
                remainingCredit: selectedOption?.remainingCredit != null ? get2DecimalPointsWithCommas(selectedOption?.remainingCredit) : null,
                remainingRequest: selectedOption?.remainingRequest,
                currency: initialValues?.currency ?? "THB",
                currencyDisplay: i18n.language === "en" ? "THB" : "บาท",
                attachment: selectedOption?.attachmentFlag ?? initialValues?.attachment ?? null,
                reject: initialValues?.reject
            });

            // * recompute vat breakdown in case initialValues didn't already carry it
            if (initialValues?.totalExpense != null && initialValues?.amountExcludeVat == null) {
                handleTotalExpenseChange(initialValues.totalExpense);
            }

            if (initialValues?.attachFile?.[0] || initialValues?.attachFileFs) {
                const fileUrls = [];
                const fileNames = [];
                const fileSizes = [];
                const fileTypes = [];
                const fileList = [];

                for (let index = 0; index < initialValues?.attachFile?.length; index++) {
                    const fileByte = initialValues.attachFile[index];
                    const fileType = initialValues?.attachFileType?.[index];
                    const fileName = initialValues?.attachFileName?.[index];

                    if (typeof fileByte === "string") {
                        const blob = new Blob(
                            [Uint8Array.from(atob(fileByte), (c) => c.charCodeAt(0))],
                            { type: fileType }
                        );
                        const fileUrl = URL.createObjectURL(blob);
                        const fileSizeInMB = (blob.size / (1024 * 1024)).toFixed(2);

                        fileTypes.push(fileType);
                        fileUrls.push(fileUrl);
                        fileNames.push(fileName);
                        fileSizes.push(fileSizeInMB);
                    }

                    const dataURL = `data:${fileType};base64,${fileByte}`;
                    const file = dataURLtoFile(dataURL, fileName);
                    fileList.push(file);
                }

                for (let index = 0; index < initialValues?.attachFileFs?.length; index++) {
                    const fileByte = initialValues?.attachFileFs?.[index]?.fileByte;
                    const fileType = initialValues?.attachFileFs?.[index]?.fileType;
                    const fileName = initialValues?.attachFileFs?.[index]?.fileName;

                    if (typeof fileByte === "string") {
                        const blob = new Blob(
                            [Uint8Array.from(atob(fileByte), (c) => c.charCodeAt(0))],
                            { type: fileType }
                        );
                        const fileUrl = URL.createObjectURL(blob);
                        const fileSizeInMB = (blob.size / (1024 * 1024)).toFixed(2);

                        fileTypes.push(fileType);
                        fileUrls.push(fileUrl);
                        fileNames.push(fileName);
                        fileSizes.push(fileSizeInMB);
                    }

                    const dataURL = `data:${fileType};base64,${fileByte}`;
                    const file = dataURLtoFile(dataURL, fileName);
                    fileList.push(file);
                }

                setFileType(fileTypes);
                setImageUrl(fileUrls);
                seeFileName(fileNames);
                setInitialValuesFileName(fileNames);
                setInitialValuesImageUrl(fileUrls);
                setInitialValuesFileList(fileList);
                setInitialValuesFileType(fileTypes);
                setfileSizeInMB(fileSizes);
            } else {
                setImageUrl(null);
            }
        }
    }, [initialValues, form, EmployeeWelfareDropdown]);

    return (
        <FormAntd form={form} onFinish={updateMyTxnExpense}>
            <FormItem shouldUpdate={(prev, curv) => {
                return prev.welfareTypeId !== curv.welfareTypeId ||
                    prev.attachment !== curv.attachment
            }}>
                {({ getFieldValue, resetFields, setFieldValue }) => {
                    const attachment = getFieldValue("attachment");

                    return (
                        <Space direction="vertical" size={24} style={{ width: "100%" }}>
                            <Row gutter={[0, 16]}>
                                <Col span={24}>
                                    <FormSelect
                                        name="welfareTypeId"
                                        label={t("expense.expense_type")}
                                        placeholder={t("common.pleaseSelect")}
                                        size="large"
                                        options={EmployeeWelfareDropdown}
                                        disabled={isViewExpenseForm}
                                        onChange={(val, item) => {
                                            resetFields([
                                                "travelBy",
                                                "projectId",
                                                "startLocation",
                                                "destination",
                                                "distance",
                                                "totalNights",
                                                "totalMinutes",
                                                "userRights",
                                                "description",
                                            ]);

                                            const selectedOption = EmployeeWelfareDropdown.find(opt => opt.value === val);

                                            setWelfareTypeCode(selectedOption?.code);
                                            form.setFieldValue("welfareTypeCode", selectedOption?.code);
                                            form.setFieldValue("attachment", selectedOption?.attachmentFlag);
                                            form.setFieldValue("remainingCredit", selectedOption?.remainingCredit != null
                                                ? get2DecimalPointsWithCommas(selectedOption.remainingCredit)
                                                : null);
                                            form.setFieldValue("remainingRequest", selectedOption?.remainingRequest);
                                        }}
                                        required
                                    />
                                </Col>

                                <Col span={12} style={{ paddingRight: "12px" }}>
                                    <FormDatePicker
                                        name="startDate"
                                        label={t("start-date")}
                                        placeholder={t("common.pleaseSelect")}
                                        size="large"
                                        required
                                        disabled={isViewExpenseForm}
                                    />
                                </Col>
                                <Col span={12} style={{ paddingLeft: "12px" }}>
                                    <FormDatePicker
                                        name="endDate"
                                        label={t("end-date")}
                                        placeholder={t("common.pleaseSelect")}
                                        size="large"
                                        required
                                        disabled={isViewExpenseForm}
                                    />
                                </Col>
                                <Row gutter={[0, 16]}>
                                    <Col span={12} style={{ paddingRight: "12px" }}>
                                        <FormInput
                                            name="remainingCredit"
                                            label={t("expense.remaining_balance")}
                                            placeholder={t("unlimited")}
                                            textAlign="right"
                                            size="large"
                                            disabled
                                        />
                                    </Col>

                                    <Col span={12} style={{ paddingLeft: "12px" }}>
                                        <FormInput
                                            name="remainingRequest"
                                            label={t("expense.remaining_request")}
                                            placeholder={t("unlimited")}
                                            textAlign="right"
                                            size="large"
                                            disabled
                                        />
                                    </Col>
                                </Row>

                                {welfareTypeCode === "WELFARE_SUBCATEGORY_1" && (
                                    <>
                                        <Col span={24} >
                                            <FormSelect
                                                name="travelBy"
                                                label={t('expense.travel_directions')}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                disabled={isViewExpenseForm}
                                                options={CommonTypeByCode}
                                                required
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <FormSelect
                                                name="projectId"
                                                label={t("my_timesheet.label.select_proj")}
                                                placeholder={t("common.pleaseSelect")}
                                                size="large"
                                                options={projectOptions}
                                                disabled={isViewExpenseForm}
                                                required
                                            />
                                        </Col>

                                        <Col span={12} style={{ paddingRight: "12px" }}>
                                            <FormInput
                                                name="startLocation"
                                                label={t("expense.starting_point")}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                disabled={isViewExpenseForm}
                                                required
                                            />
                                        </Col>
                                        <Col span={12} style={{ paddingLeft: "12px" }}>
                                            <FormInput
                                                name="destination"
                                                label={t("expense.destination")}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                disabled={isViewExpenseForm}
                                                required
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <FormInputNumber
                                                name="distanceKm"
                                                label={t("expense.distance")}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                controls={false}
                                                precision={0}
                                                disabled={isViewExpenseForm}
                                                required
                                            />
                                        </Col>
                                    </>
                                )}


                                {welfareTypeCode === "WELFARE_SUBCATEGORY_2" && (
                                    <>
                                        <Col span={12} style={{ paddingRight: "12px" }}>
                                            <FormInput
                                                name="startLocation"
                                                label={t("expense.starting_point")}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                disabled={isViewExpenseForm}
                                                required
                                            />
                                        </Col>
                                        <Col span={12} style={{ paddingLeft: "12px" }}>
                                            <FormInput
                                                name="destination"
                                                label={t("expense.destination")}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                disabled={isViewExpenseForm}
                                                required
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <FormSelect
                                                name="projectId"
                                                label={t("my_timesheet.label.select_proj")}
                                                placeholder={t("common.pleaseSelect")}
                                                size="large"
                                                options={projectOptions}
                                                disabled={isViewExpenseForm}
                                            />
                                        </Col>

                                        <Col span={24}>
                                            <FormInputNumber
                                                name="distanceKm"
                                                label={t("expense.distance")}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                controls={false}
                                                precision={0}
                                                disabled={isViewExpenseForm}
                                                required
                                            />
                                        </Col>
                                    </>
                                )}


                                {welfareTypeCode === "WELFARE_SUBCATEGORY_3" && (
                                    <>
                                        <Col span={24}>
                                            <FormSelect
                                                name="projectId"
                                                label={t("my_timesheet.label.select_proj")}
                                                placeholder={t("common.pleaseSelect")}
                                                size="large"
                                                options={projectOptions}
                                                disabled={isViewExpenseForm}
                                            />
                                        </Col>

                                        <Col span={24}>
                                            <FormInputNumber
                                                name="totalNights"
                                                label={t("expense.number_of_stay")}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                controls={false}
                                                precision={0}
                                                disabled={isViewExpenseForm}
                                            />
                                        </Col>
                                    </>

                                )}

                                {welfareTypeCode === "WELFARE_SUBCATEGORY_4" && (
                                    <>
                                        <Col span={24}>
                                            <FormSelect
                                                name="projectId"
                                                label={t("my_timesheet.label.select_proj")}
                                                placeholder={t("common.pleaseSelect")}
                                                size="large"
                                                options={projectOptions}
                                                disabled={isViewExpenseForm}
                                            />
                                        </Col>

                                        <Col span={24} >
                                            <FormTimePicker
                                                name="totalMinutes"
                                                label={t("expense.duration")}
                                                placeholder={t("common.pleaseSelect")}
                                                size="large"
                                                showNow={false}
                                                minuteStep={30}
                                                disabled={isViewExpenseForm}
                                            />
                                        </Col>
                                    </>
                                )}

                                {welfareTypeCode === "WELFARE_SUBCATEGORY_5" && (
                                    <>
                                        <Col span={24}>
                                            <FormSelect
                                                name="userRights"
                                                label={t('welfare_list.Select_user_rights')}
                                                placeholder={employeeFullname}
                                                size="large"
                                                disabled
                                            />
                                        </Col>
                                    </>

                                )}

                                {welfareTypeCode === "WELFARE_SUBCATEGORY_6" && (
                                    <>
                                        <Col span={24}>
                                            <FormSelect
                                                name="projectId"
                                                label={t("my_timesheet.label.select_proj")}
                                                placeholder={t("common.pleaseSelect")}
                                                size="large"
                                                options={projectOptions}
                                                disabled={isViewExpenseForm}
                                            />
                                        </Col>
                                    </>

                                )}

                                {/* ===== Invoice detail block: shared across every expense type ===== */}
                                {welfareTypeCode && (
                                    <>
                                        <Col span={24}>
                                            <label className={cx("label", styles.label)}>
                                                {t("expense.invoice_detail")}
                                            </label>
                                        </Col>
                                        <Row>
                                            <Col span={8} style={{ paddingRight: "12px" }}>
                                                <FormDatePicker
                                                    name="invoiceDate"
                                                    label={t("expense.invoice_date")}
                                                    placeholder={t("common.pleaseSelect")}
                                                    size="large"
                                                    required
                                                    disabled={isViewExpenseForm}
                                                />
                                            </Col>
                                            <Col span={8} >
                                                <FormInput
                                                    name="invoiceNumber"
                                                    label={t("expense.invoice_number")}
                                                    placeholder={t("common.please_fill")}
                                                    size="large"
                                                    // required
                                                    disabled={isViewExpenseForm}
                                                />
                                            </Col>
                                            <Col span={8} style={{ paddingLeft: "12px" }}>
                                                <FormInput
                                                    name="currencyDisplay"
                                                    label={t("expense.currency")}
                                                    size="large"
                                                    disabled={isViewExpenseForm}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={8} style={{ paddingRight: "12px" }}>
                                                <FormInputNumber
                                                    name="totalExpense"
                                                    label={t("expense.amount_Bath")}
                                                    placeholder={t("common.please_fill")}
                                                    size="large"
                                                    controls={false}
                                                    textAlign="right"
                                                    required
                                                    // onChange={handleTotalExpenseChange}
                                                    disabled={isViewExpenseForm}
                                                />
                                            </Col>
                                            <Col span={8} >
                                                <FormInputNumber
                                                    name="amountExcludeVat"
                                                    label={t("expense.amount_exclude_vat")}
                                                    textAlign="right"
                                                    controls={false}
                                                    size="large"
                                                    disabled={isViewExpenseForm}
                                                />
                                            </Col>
                                            <Col span={8} style={{ paddingLeft: "12px" }}>
                                                <FormInputNumber
                                                    name="vatAmount"
                                                    label={t("expense.vat")}
                                                    textAlign="right"
                                                    controls={false}
                                                    size="large"
                                                    disabled={isViewExpenseForm}
                                                />
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                <Col span={24}>
                                    <FormInput
                                        name="description"
                                        label={t("common.desciption")}
                                        placeholder={t("common.please_fill")}
                                        size="large"
                                        rows="4"
                                        type="textarea"
                                        required
                                        disabled={isViewExpenseForm}
                                    />
                                </Col>
                                {attachment === 'Y' && !isViewExpenseForm && (
                                    <Col span={24}>
                                        <>
                                            <Dragger
                                                name="attachFile"
                                                multiple={false}
                                                showUploadList={false}
                                                onRemove={() => {
                                                    onDeleteFile();
                                                }}
                                                onChange={(e) => {
                                                    if (e.event) {
                                                        onAttachFileChange({
                                                            attachFile: e,
                                                            setFieldValue: (key, val) => form.setFieldValue(key, val),
                                                            setImageUrl,
                                                            seeFileName,
                                                            initialValuesImageUrl,
                                                            initialValuesFileName,
                                                            initialValuesFileType,
                                                            initialValuesFileList,
                                                            setInitialValuesFileName,
                                                            setInitialValuesFileType,
                                                            setInitialValuesImageUrl,
                                                            setInitialValuesFileList,
                                                            setFileType
                                                        });
                                                    }
                                                }}
                                                style={{
                                                    border: "1px solid #EAECF0",
                                                    borderRadius: "10px",
                                                    background: "#FAFAFA",
                                                    padding: "20px",
                                                }}
                                            >
                                                <p className="ant-upload-drag-icon">
                                                    <CloudUploadOutlined style={{ fontSize: "32px", color: "#888" }} />
                                                </p>
                                                <p
                                                    className="ant-upload-text"
                                                    style={{ fontSize: "16px", fontWeight: "500", color: "#4A4A4A" }}
                                                >
                                                    {t("description.Select the desired file or drag and drop")}
                                                </p>
                                            </Dragger>
                                            <p>{t('description.Supported files mb')}</p>
                                        </>
                                    </Col>
                                )}

                                {imageUrl && (
                                    <>
                                        {imageUrl?.map((attachFile, index) => (
                                            <Col span={24} key={attachFile + index} style={index === 0 ? { marginTop: "24px" } : undefined}>
                                                <Flex vertical gap={4}>
                                                    {index === 0 && (
                                                        <label className={cx("label", styles.label)}>
                                                            {t('employee.label.attachment-file')}
                                                        </label>
                                                    )}
                                                    <Row>
                                                        <div
                                                            style={{
                                                                border: "2px solid var(--button-color)",
                                                                borderRadius: "10px",
                                                                padding: "10px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                                width: "100%",
                                                                maxWidth: "600px",
                                                                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                                                            }}
                                                        >
                                                            <a
                                                                onClick={() => { openBase64InNewTab(attachFile, fileType[index]) }}
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    textDecoration: "none",
                                                                }}
                                                            >
                                                                <img
                                                                    src={attachFile}
                                                                    alt="uploaded"
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.style.display = "none";
                                                                        const fallbackElement = e.target.nextElementSibling;
                                                                        if (fallbackElement) fallbackElement.style.display = "block";
                                                                    }}
                                                                    style={{
                                                                        width: "50px",
                                                                        height: "50px",
                                                                        objectFit: "cover",
                                                                        borderRadius: "5px",
                                                                        marginRight: "10px",
                                                                    }}
                                                                />
                                                                <div style={{ flex: 1 }}>
                                                                    <div style={{ fontWeight: "bold", color: "#333", width: "350px" }}>{fileName[index]}</div>
                                                                    <div style={{ fontSize: "12px", color: "#888" }}>{fileSizeInMB[index]} MB</div>
                                                                </div>
                                                            </a>
                                                            <Button
                                                                type="default"
                                                                style={{
                                                                    background: "none",
                                                                    border: "none",
                                                                    color: "#888",
                                                                    cursor: "pointer",
                                                                    fontSize: "18px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                }}

                                                                onClick={() => {
                                                                    const currentAttachFile = getFieldValue("attachFile") || [];
                                                                    const currentAttachFileType = getFieldValue("attachFileType") || [];
                                                                    const currentAttachFileName = getFieldValue("attachFileName") || [];

                                                                    const newImage = imageUrl.filter((_, i) => i !== index);
                                                                    const newfileName = fileName.filter((_, i) => i !== index);
                                                                    const newfileSize = fileSizeInMB.filter((_, i) => i !== index);
                                                                    const newfileType = fileType.filter((_, i) => i !== index);

                                                                    setImageUrl(newImage);
                                                                    seeFileName(newfileName);
                                                                    setfileSizeInMB(newfileSize);
                                                                    setInitialValuesFileName(newfileName);
                                                                    setInitialValuesImageUrl(newImage);
                                                                    setInitialValuesFileType(newfileType);
                                                                    setInitialValuesFileList(currentAttachFile.filter((_, i) => i !== index));

                                                                    setFieldValue("attachFile", currentAttachFile.filter((_, i) => i !== index));
                                                                    setFieldValue("attachFileType", currentAttachFileType.filter((_, i) => i !== index));
                                                                    setFieldValue("attachFileName", currentAttachFileName.filter((_, i) => i !== index));
                                                                }}
                                                            >
                                                                &#x2715;
                                                            </Button>
                                                        </div>
                                                    </Row>
                                                </Flex>
                                            </Col>
                                        ))}
                                    </>
                                )}
                            </Row>



                            {isApprove ?
                                <Row style={{ gap: "8px" }} justify={"end"}>
                                    <Button
                                        type="default"
                                        style={{ borderRadius: "8px", height: "40px" }}
                                        onClick={() => {
                                            onReject({
                                                ...selectedExpenseRecord,
                                                table: "PendingApprovalExpenseTable"
                                            });
                                            handleCancel();
                                        }}
                                        size="large"
                                    >
                                        {t("request_approval.label.not_approved")}</Button>
                                    <Button
                                        type="primary"
                                        style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color" }}
                                        onClick={() => {
                                            onApprove({
                                                ...selectedExpenseRecord,
                                                table: "PendingApprovalExpenseTable"
                                            });
                                            handleCancel();
                                        }}
                                        size="large"
                                    >{t("request_approval.label.approve")}</Button>
                                </Row>

                                : <Flex justify="end">
                                    <Space direction="horizontal" size={12}>
                                        <Button
                                            type="default"
                                            style={{ height: "40px", borderRadius: "8px" }}
                                            onClick={() => {
                                                resetFields();
                                                setIsExpenseModalOpen(false);
                                            }}
                                        >
                                            {t("common.cancel")}
                                        </Button>
                                        {
                                            getFieldValue("reject") === 'reject' || getFieldValue("approveStatusEn") === 'Approved' ?
                                                <>
                                                    <Button
                                                        type="primary"
                                                        style={{ height: "40px", borderRadius: "8px" }}
                                                        onClick={() => {
                                                            onReject(getFieldValue());
                                                        }}
                                                    >
                                                        {t("common.reject")}
                                                    </Button>
                                                </> : null
                                        }
                                        {!isViewExpenseForm ?
                                            <>
                                                <Button
                                                    type="default"
                                                    style={{ height: "40px", borderRadius: "8px" }}
                                                    onClick={() => updateMyTxnExpenseDraft(form)}
                                                >
                                                    {t("common.draft")}
                                                </Button>
                                                <Button
                                                    htmlType="submit"
                                                    type="primary"
                                                    style={{
                                                        height: "40px",
                                                        borderRadius: "8px",
                                                        backgroundColor: "var(--button-color)",
                                                        boxShadow: "none",
                                                    }}
                                                >
                                                    {t("my_timesheet.label.approve")}
                                                </Button>
                                            </>
                                            : null}
                                    </Space>
                                </Flex>}
                        </Space>
                    );
                }}
            </FormItem>
        </FormAntd>
    );
};

export default EditExpenseForm;